module.exports = __webpack_public_path__ + "img/rightPanel.bf9cea52.jpg";